import { render } from "./MdSidebar.vue?vue&type=template&id=6f38d93e&scoped=true&ts=true"
import script from "./MdSidebar.vue?vue&type=script&lang=ts"
export * from "./MdSidebar.vue?vue&type=script&lang=ts"

import "./MdSidebar.vue?vue&type=style&index=0&id=6f38d93e&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f38d93e"]])

export default __exports__